import { useEffect, useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { formatARS } from "../../lib/site";

const FIELDS = [["alias", "Alias"], ["cbu", "CBU/CVU"], ["holder", "Titular"], ["cuit", "CUIT"], ["bank", "Banco"]];
const fmt = (s) => (s ? new Date(s).toLocaleString("es-AR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: "America/Argentina/Buenos_Aires" }) : "");

/** Datos de transferencia activos (o null). */
export const useTransfer = () => {
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/payments/transfer").then((r) => setT(r.data?.enabled ? r.data : null)).catch(() => setT(null)); }, []);
  return t;
};

const copy = (v) => navigator.clipboard?.writeText(v).then(() => toast.success("Copiado")).catch(() => {});

/** Instrucciones para pagar una reserva por transferencia. */
export const TransferBox = ({ b, testid = "transfer-box" }) => {
  const t = b?.transfer ?? {};
  return (
    <div data-testid={testid} className="rounded-2xl bg-amber-50 p-4 text-left text-sm text-amber-950">
      <p>Transferí <b>{formatARS(b?.total ?? 0)}</b>{b?.expires_at ? <> antes del <b>{fmt(b.expires_at)} hs</b></> : null}. Si no, la reserva vence.</p>
      <dl className="mt-3 space-y-1.5">
        {FIELDS.filter(([k]) => t[k]).map(([k, l]) => (
          <div key={k} className="flex items-center justify-between gap-2">
            <dt className="text-amber-900/80">{l}</dt>
            <dd className="flex items-center gap-1 font-semibold">
              <span data-testid={`${testid}-${k}`} className="break-all">{t[k]}</span>
              {["alias", "cbu"].includes(k) && <button type="button" onClick={() => copy(t[k])} aria-label={`Copiar ${l}`} data-testid={`${testid}-copy-${k}`} className="rounded-full p-1 hover:bg-amber-100"><Copy className="h-3.5 w-3.5" /></button>}
            </dd>
          </div>
        ))}
      </dl>
      <p className="mt-3">Poné tu código <b className="font-mono">{b?.code}</b> en el concepto. Cuando se acredite te confirmamos el pasaje por email.</p>
    </div>
  );
};
